var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSalesIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.8333 5.5713H22.4444C22.0772 5.56977 21.7209 5.69311 21.4372 5.92C21.1535 6.14688 20.9602 6.46305 20.8908 6.81386C20.8213 7.16467 20.88 7.52807 21.0567 7.84124C21.2335 8.15441 21.5171 8.39768 21.8587 8.52898L24.2834 9.47215C24.6238 9.60396 24.9063 9.84706 25.0823 10.1596C25.2584 10.4722 25.3169 10.8346 25.2479 11.1846C25.1789 11.5346 24.9866 11.8503 24.7042 12.0773C24.4218 12.3043 24.0668 12.4285 23.7005 12.4284H21.3087",
    stroke: "#FFFFFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0693 5.57157V4.42871",
    stroke: "#FFFFFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0693 14.7144V12.4287",
    stroke: "#FFFFFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5171 17C27.0877 17 30.7929 13.4183 30.7929 9.00001C30.7929 4.58173 27.0877 1 22.5171 1C17.9464 1 14.2412 4.58173 14.2412 9.00001C14.2412 13.4183 17.9464 17 22.5171 17Z",
    stroke: "#FFFFFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.552 24.6133L30.3937 21.6404L30.4549 21.6225C30.9522 21.5077 31.4722 21.5874 31.9178 21.8467C32.3634 22.1059 32.7041 22.527 32.8764 23.0313C33.0486 23.5356 33.0406 24.0886 32.8539 24.5872C32.6671 25.0857 32.3143 25.4957 31.8614 25.7405C14.6004 35.1471 19.0034 34.722 1 28.4095",
    stroke: "#FFFFFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1 17.0009H4.10203C7.7076 16.9589 11.2053 18.4037 13.9524 21.0697L14.0102 21.1277H19.7913C20.3679 21.1277 20.9209 21.3891 21.3287 21.8546C21.7364 22.32 21.9655 22.9513 21.9655 23.6095C21.9659 24.2658 21.7385 24.8955 21.3332 25.3609C20.9278 25.8264 20.3775 26.0896 19.8026 26.093L11.0125 26.1429",
    stroke: "#FFFFFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSalesIcon);
export default __webpack_public_path__ + "static/media/sales-icon.e01a23435fed226c3e3a9df1ea7f5967.svg";
export { ForwardRef as ReactComponent };